import React, { useCallback, useState } from "react";
import {
  Location,
  LocationAttr,
  LocationFormInput,
} from "../Locations/Location";
import { Mode } from "../Locations/AddEditLocationForm";
import { Card } from "@velocity-ehs/component-library";
import FormSkeleton from "../../sharedComponents/FormSkeleton";
import { useTranslation } from "react-i18next";
import { AddEditLocationFormNew } from "./AddEditLocationFormNew";
import { LocationActions } from "../../../hooks/useLocationMutation";

interface Props {
  mode: Mode;
  location?: LocationAttr;
  mutations: (
    action: LocationActions,
    input: LocationFormInput,
    locationId?: string
  ) => Promise<any>;
  isLoading: boolean;
  readOnly: boolean;
}

const LocationProfileNew: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <h2>{t("universal_Details")}</h2>
      <Card showHeader={false}>
        {!props.isLoading ? (
          <AddEditLocationFormNew
            location={props.location as Location}
            mode={props.mode}
            mutations={props.mutations}
            isLoading={props.isLoading}
            readOnly={props.readOnly}
          />
        ) : (
          <FormSkeleton rows={5} />
        )}
      </Card>
    </>
  );
};

export { LocationProfileNew };
